module.exports = __webpack_public_path__ + "f566f87d10a38e3e947984b526ae2965.pdf";